import ENDPOINTS from 'api/endpoints';
import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  CreateWebRTCConnectionRequest,
  GetWebRTCConnectionResponse,
  WebRTCConnectionResponse,
} from './types';

export const createWebRTCConnection = (body: CreateWebRTCConnectionRequest) =>
  doPost<WebRTCConnectionResponse>(
    ENDPOINTS.WEBRTC_CONNECTIONS,
    LOGGER_TYPE.AGENT_STREAM,
    body,
    { prefix: 'sourcerer' },
  );

export const getWebRTCConnection = (connectionId: string) =>
  doGet<GetWebRTCConnectionResponse>(
    generateNextPath(ENDPOINTS.WEBRTC_CONNECTION, { connectionId }),
    LOGGER_TYPE.AGENT_STREAM,
    { prefix: 'sourcerer', noAuth: true },
  );
